/* ============================================================
   Section Formulaire SAV - FOG
   Stepper 5 etapes, validation par etape, upload direct signe
   (Supabase Storage) puis creation de la demande via fog-api.
   ============================================================ */
(function () {
  "use strict";

  var MAX_BYTES = 10 * 1024 * 1024; // 10 Mo
  var MIN_DESC = 20;
  var SLOTS = {
    photo_product: { image: true },
    photo_serial: { image: true },
    invoice: { image: true, pdf: true },
  };

  /* Type MIME deduit de l'extension quand le navigateur n'en donne pas : un
     .heic/.heif a souvent file.type vide sur ordinateur (Windows sans codec HEIF).
     Partage par la validation, l'envoi du formulaire et les reponses (constat
     L5-03 : seule la validation l'ignorait, et refusait la photo annoncee). */
  var MIME_BY_EXT = { jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", webp: "image/webp", heic: "image/heic", heif: "image/heif", pdf: "application/pdf" };
  function effectiveType(file) {
    return file.type || MIME_BY_EXT[fileExt(file)] || "";
  }

  /* Libelles : snippets/i18n-js.liquid (cles sav.*), lus au moment de l'appel. Spec 07.
     assets/i18n.js decode les entites : ces textes s'ecrivent en textContent ou en
     attribut, jamais en innerHTML. Les messages renvoyes par fog-api (data.error)
     restent affiches tels quels. */
  function i18n(cle, vars) {
    return window.FOG_I18N.t(cle, vars);
  }

  function init(form) {
    if (!form || form.dataset.savReady) return;
    form.dataset.savReady = "1";

    // Arrive sur le SAV connecte : on efface le drapeau de retour.
    try { localStorage.removeItem("fog_sav_return"); } catch (e) {}

    // Appels via l'App Proxy Shopify (/apps/fog) : meme origine, requete signee par
    // Shopify qui injecte l'identite du client connecte (logged_in_customer_id). Le
    // fog-api verifie cette signature : l'identite n'est plus transmise par le corps.
    var apiBase = "/apps/fog";
    var panels = Array.prototype.slice.call(form.querySelectorAll(".sav-panel"));
    var dots = Array.prototype.slice.call(form.querySelectorAll("[data-step-dot]"));
    var feedback = form.querySelector("[data-feedback]");
    var successEl = form.querySelector("[data-success]");
    var submitBtn = form.querySelector("[data-submit]");
    var consent = form.querySelector("[data-consent]");
    var current = 1;
    var files = {}; // slot -> File

    // Profil client 03f : lu depuis les data-attributes poses par Liquid.
    var profileComplete = form.dataset.profileComplete === "true";
    var accountType    = form.dataset.accountType    || "";
    var custLang       = form.dataset.customerLang   || "";
    var custCompany    = form.dataset.customerCompany || "";
    var custVat        = form.dataset.customerVat     || "";
    var custCountry    = form.dataset.customerCountry || "";
    var custActivity   = form.dataset.customerActivity || "";

    // ---- Navigation -------------------------------------------------------
    function show(step) {
      current = step;
      panels.forEach(function (p) {
        p.classList.toggle("is-active", Number(p.dataset.step) === step);
      });
      dots.forEach(function (d) {
        var n = Number(d.dataset.stepDot);
        d.classList.toggle("is-active", n === step);
        d.classList.toggle("is-done", n < step);
      });
      if (step === 5) buildRecap();
      var top = form.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: "smooth" });
    }

    form.querySelectorAll("[data-next]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (validateStep(current)) show(Math.min(current + 1, 5));
      });
    });
    form.querySelectorAll("[data-prev]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        show(Math.max(current - 1, 1));
      });
    });

    /* Remise a zero pour une nouvelle demande (constat L5-01) : apres un envoi,
       l'ecran de succes reste affiche ; le bouton « Ouvrir une nouvelle demande »
       de la liste emet fog:sav-reset. form.reset() garde les valeurs pre-remplies
       par Liquid (attribut value) ; le champ « autre panne » et la recherche
       produit se resynchronisent sur l'evenement reset (cf. plus bas). */
    function resetForm() {
      form.reset();
      files = {};
      Object.keys(SLOTS).forEach(function (slot) {
        var field = form.querySelector('[data-file-field="' + slot + '"]');
        if (!field) return;
        var placeholder = field.querySelector("[data-file-placeholder]");
        var preview = field.querySelector("[data-file-preview]");
        var replace = field.querySelector("[data-file-replace]");
        field.classList.remove("is-filled");
        if (placeholder) placeholder.hidden = false;
        if (preview) { preview.hidden = true; preview.innerHTML = ""; }
        if (replace) replace.hidden = true;
      });
      form.querySelectorAll(".sav-field.has-error").forEach(function (f) { f.classList.remove("has-error"); });
      form.querySelectorAll("[data-error-for]").forEach(function (e) { e.textContent = ""; });
      clearFeedback();
      submitBtn.disabled = false;
      submitBtn.classList.remove("is-loading");
      submitBtn.textContent = i18n("sav.step5.submit");
      successEl.hidden = true;
      var progress = form.querySelector("[data-sav-progress]");
      if (progress) progress.style.display = "";
      current = 1;
      panels.forEach(function (p) { p.classList.toggle("is-active", Number(p.dataset.step) === 1); });
      dots.forEach(function (d) {
        d.classList.toggle("is-active", Number(d.dataset.stepDot) === 1);
        d.classList.remove("is-done");
      });
    }
    document.addEventListener("fog:sav-reset", resetForm);

    // ---- Type de panne : champ "autre" revele a la demande ----------------
    // Cles = valeurs envoyees a fog-api (stockees) : elles restent en francais.
    var PANNE_LABELS = {
      led: i18n("sav.faults.led"),
      transformateur: i18n("sav.faults.transformer"),
      variateur: i18n("sav.faults.dimmer"),
      suspension: i18n("sav.faults.suspension"),
      fixation_barre_led: i18n("sav.faults.bar_mount"),
      autre: i18n("sav.faults.other"),
    };
    var panneType = form.querySelector("#sav-panne-type");
    var panneAutreWrap = form.querySelector("[data-panne-autre]");
    var panneAutreInput = form.querySelector("#sav-panne-autre");
    function syncPanneAutre() {
      if (!panneType || !panneAutreWrap) return;
      var isOther = panneType.value === "autre";
      panneAutreWrap.hidden = !isOther;
      panneAutreWrap.classList.toggle("is-visible", isOther);
      if (!isOther && panneAutreInput) panneAutreInput.value = "";
    }
    if (panneType) {
      panneType.addEventListener("change", syncPanneAutre);
      syncPanneAutre();
      // reset n'emet pas change ; les valeurs ne sont remises qu'apres l'evenement.
      form.addEventListener("reset", function () { setTimeout(syncPanneAutre, 0); });
    }

    // ---- Produit : combobox recherchable (tri alpha + filtre) -------------
    // Le <select> #sav-product reste la source de verite : validation, recap et
    // submit lisent #sav-product.value. On le masque et on superpose un champ de
    // recherche + une liste filtrable, triee alphabetiquement. Sans JS, le select
    // natif reste pleinement utilisable (repli progressif).
    setupProductCombobox();
    function setupProductCombobox() {
      var box = form.querySelector("[data-sav-combobox]");
      if (!box) return;
      var select = box.querySelector("select");
      if (!select) return;

      var options = Array.prototype.slice.call(select.options)
        .filter(function (o) { return o.value !== ""; })
        .map(function (o) { return { value: o.value, label: o.text }; })
        .sort(function (a, b) {
          return a.label.localeCompare(b.label, window.FOG_I18N.intl("fr"), { sensitivity: "base" });
        });
      if (!options.length) return;

      var listId = "sav-product-list";
      var input = document.createElement("input");
      input.type = "text";
      input.className = "sav-input sav-combobox__search";
      input.id = "sav-product-search";
      input.autocomplete = "off";
      input.placeholder = i18n("sav.step2.search_placeholder");
      input.setAttribute("role", "combobox");
      input.setAttribute("aria-autocomplete", "list");
      input.setAttribute("aria-expanded", "false");
      input.setAttribute("aria-controls", listId);

      var list = document.createElement("ul");
      list.className = "sav-combobox__list";
      list.id = listId;
      list.setAttribute("role", "listbox");
      list.hidden = true;

      select.classList.add("is-enhanced");
      select.setAttribute("tabindex", "-1");
      select.setAttribute("aria-hidden", "true");

      box.appendChild(input);
      box.appendChild(list);

      var label = form.querySelector('label[for="sav-product"]');
      if (label) label.setAttribute("for", "sav-product-search");

      var filtered = options.slice();
      var activeIndex = -1;

      function norm(s) {
        return (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      }
      function currentLabel() {
        if (!select.value) return "";
        for (var i = 0; i < options.length; i++) {
          if (options[i].value === select.value) return options[i].label;
        }
        return "";
      }
      function renderList() {
        list.innerHTML = "";
        if (!filtered.length) {
          var empty = document.createElement("li");
          empty.className = "sav-combobox__empty";
          empty.textContent = i18n("sav.step2.no_result");
          list.appendChild(empty);
          return;
        }
        filtered.forEach(function (opt, i) {
          var li = document.createElement("li");
          li.className = "sav-combobox__option";
          li.id = "sav-product-opt-" + i;
          li.setAttribute("role", "option");
          li.textContent = opt.label;
          if (opt.value === select.value) li.setAttribute("aria-selected", "true");
          li.addEventListener("mousedown", function (e) {
            e.preventDefault(); // conserve le focus sur l'input
            choose(opt);
          });
          list.appendChild(li);
        });
      }
      function open() {
        renderList();
        list.hidden = false;
        input.setAttribute("aria-expanded", "true");
      }
      function close() {
        list.hidden = true;
        input.setAttribute("aria-expanded", "false");
        input.removeAttribute("aria-activedescendant");
        activeIndex = -1;
      }
      function applyFilter(q) {
        var nq = norm(q);
        filtered = nq
          ? options.filter(function (o) { return norm(o.label).indexOf(nq) !== -1; })
          : options.slice();
        activeIndex = -1;
      }
      function choose(opt) {
        select.value = opt.value;
        input.value = opt.label;
        var field = input.closest(".sav-field");
        if (field) {
          field.classList.remove("has-error");
          var err = field.querySelector('[data-error-for="product_label"]');
          if (err) err.textContent = "";
        }
        close();
      }
      function setActive(i) {
        var items = list.querySelectorAll(".sav-combobox__option");
        if (!items.length) return;
        activeIndex = (i + items.length) % items.length;
        Array.prototype.forEach.call(items, function (el, idx) {
          el.classList.toggle("is-active", idx === activeIndex);
        });
        var active = items[activeIndex];
        input.setAttribute("aria-activedescendant", active.id);
        active.scrollIntoView({ block: "nearest" });
      }

      input.value = currentLabel();
      form.addEventListener("reset", function () {
        setTimeout(function () { close(); input.value = currentLabel(); }, 0);
      });

      input.addEventListener("focus", function () {
        input.select();
        applyFilter("");
        open();
      });
      input.addEventListener("input", function () {
        applyFilter(input.value);
        open();
      });
      input.addEventListener("keydown", function (e) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          if (list.hidden) open();
          setActive(activeIndex + 1);
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          if (list.hidden) open();
          setActive(activeIndex - 1);
        } else if (e.key === "Enter") {
          if (!list.hidden && activeIndex >= 0 && filtered[activeIndex]) {
            e.preventDefault();
            choose(filtered[activeIndex]);
          }
        } else if (e.key === "Escape") {
          close();
        }
      });
      input.addEventListener("blur", function () {
        // Laisse le mousedown d'une option s'executer avant de fermer.
        setTimeout(function () {
          close();
          var lbl = currentLabel();
          if (input.value !== lbl) input.value = lbl;
        }, 120);
      });
    }

    // ---- Champs fichiers --------------------------------------------------
    Object.keys(SLOTS).forEach(function (slot) {
      var field = form.querySelector('[data-file-field="' + slot + '"]');
      if (!field) return;
      var input = field.querySelector("[data-file-input]");
      var placeholder = field.querySelector("[data-file-placeholder]");
      var preview = field.querySelector("[data-file-preview]");
      var replace = field.querySelector("[data-file-replace]");

      input.addEventListener("change", function () {
        var file = input.files && input.files[0];
        if (!file) return;
        var err = validateFile(slot, file);
        if (err) {
          setFieldError(field, slot, err);
          input.value = "";
          return;
        }
        clearFieldError(field, slot);
        files[slot] = file;
        renderPreview(field, placeholder, preview, replace, file);
      });

      if (replace) {
        replace.addEventListener("click", function () {
          input.value = "";
          input.click();
        });
      }
    });

    function renderPreview(field, placeholder, preview, replace, file) {
      field.classList.add("is-filled");
      placeholder.hidden = true;
      replace.hidden = false;
      preview.hidden = false;
      var sizeKb = file.size > 1048576
        ? i18n("sav.file.size_mb", { size: (file.size / 1048576).toFixed(1) })
        : i18n("sav.file.size_kb", { size: Math.round(file.size / 1024) });
      preview.innerHTML = "";
      var thumb;
      var type = effectiveType(file);
      // HEIC/HEIF : vignette illisible hors Safari, on affiche le format en pastille.
      if (type.indexOf("image/") === 0 && type !== "image/heic" && type !== "image/heif") {
        thumb = document.createElement("img");
        thumb.alt = "";
        thumb.src = URL.createObjectURL(file);
        thumb.onload = function () { URL.revokeObjectURL(thumb.src); };
      } else {
        thumb = document.createElement("span");
        thumb.className = "sav-file__preview-doc";
        thumb.textContent = type === "application/pdf" ? "PDF" : fileExt(file).toUpperCase();
      }
      var meta = document.createElement("span");
      meta.className = "sav-file__preview-meta";
      meta.innerHTML =
        '<span class="sav-file__preview-name"></span><span class="sav-file__preview-size"></span>';
      meta.querySelector(".sav-file__preview-name").textContent = file.name;
      meta.querySelector(".sav-file__preview-size").textContent = sizeKb;
      preview.appendChild(thumb);
      preview.appendChild(meta);
    }

    // ---- Validation -------------------------------------------------------
    function validateFile(slot, file) {
      if (file.size > MAX_BYTES) return i18n("sav.errors.file_too_large");
      var spec = SLOTS[slot];
      var type = effectiveType(file);
      var isImg = type.indexOf("image/") === 0;
      var isPdf = type === "application/pdf";
      if (isImg && spec.image) return null;
      if (isPdf && spec.pdf) return null;
      return spec.pdf ? i18n("sav.errors.format_image_pdf") : i18n("sav.errors.format_image");
    }

    function validateStep(step) {
      clearFeedback();
      if (step === 1) {
        // Cas profil complet (pro) : les champs sont caches et pre-remplis,
        // pas de blocage de la navigation.
        if (profileComplete) return true;

        // Cas saisie (particulier ou pro incomplet).
        var ok = true;
        var firstname = form.querySelector("#sav-firstname");
        var lastname = form.querySelector("#sav-lastname");
        var phone = form.querySelector("#sav-phone");
        var address = form.querySelector("#sav-address");
        if (!firstname || !firstname.value.trim()) {
          if (firstname) setInputError(firstname, "firstname", i18n("sav.errors.first_name"));
          ok = false;
        } else { clearInputError(firstname, "firstname"); }
        if (!lastname || !lastname.value.trim()) {
          if (lastname) setInputError(lastname, "lastname", i18n("sav.errors.last_name"));
          ok = false;
        } else { clearInputError(lastname, "lastname"); }
        if (!phone || !phone.value.trim()) {
          if (phone) setInputError(phone, "phone", i18n("sav.errors.phone"));
          ok = false;
        } else { clearInputError(phone, "phone"); }
        if (!address || !address.value.trim()) {
          if (address) setInputError(address, "address", i18n("sav.errors.address"));
          ok = false;
        } else { clearInputError(address, "address"); }
        if (!ok) return false;
      }
      if (step === 2) {
        if (!files.photo_product) {
          flashFileError("photo_product", i18n("sav.errors.photo_product"));
          return false;
        }
        var product = form.querySelector("#sav-product");
        if (!product.value.trim()) {
          setInputError(product, "product_label", i18n("sav.errors.product"));
          return false;
        }
        clearInputError(product, "product_label");
        var desc = form.querySelector("#sav-description");
        if (!desc.value || desc.value.trim().length < MIN_DESC) {
          setInputError(desc, "description", i18n("sav.errors.description"));
          return false;
        }
        clearInputError(desc, "description");
      }
      if (step === 3 && !files.photo_serial) {
        flashFileError("photo_serial", i18n("sav.errors.photo_serial"));
        return false;
      }
      // Etape 4 : facture facultative, aucun blocage.
      return true;
    }

    function flashFileError(slot, msg) {
      var field = form.querySelector('[data-file-field="' + slot + '"]');
      setFieldError(field, slot, msg);
    }
    function setFieldError(field, slot, msg) {
      if (!field) return;
      field.classList.add("has-error");
      var el = field.querySelector('[data-error-for="' + slot + '"]');
      if (el) el.textContent = msg;
    }
    function clearFieldError(field, slot) {
      if (!field) return;
      field.classList.remove("has-error");
      var el = field.querySelector('[data-error-for="' + slot + '"]');
      if (el) el.textContent = "";
    }
    function setInputError(input, key, msg) {
      input.closest(".sav-field").classList.add("has-error");
      var el = form.querySelector('[data-error-for="' + key + '"]');
      if (el) el.textContent = msg;
    }
    function clearInputError(input, key) {
      input.closest(".sav-field").classList.remove("has-error");
      var el = form.querySelector('[data-error-for="' + key + '"]');
      if (el) el.textContent = "";
    }

    // ---- Recap ------------------------------------------------------------
    // Noms de langue dans leur propre langue (endonymes) : identiques quelle que soit
    // la langue du site, donc hors locales.
    var LANG_LABELS = { FR: "Français", DE: "Deutsch", IT: "Italiano", EN: "English" };
    var ACCOUNT_TYPE_LABELS = { pro: i18n("sav.recap.type_pro"), particulier: i18n("sav.recap.type_personal") };

    function buildRecap() {
      var recap = form.querySelector("[data-recap]");
      var fullName = (val("#sav-firstname") + " " + val("#sav-lastname")).trim();
      var panneSlug = val("#sav-panne-type");
      var panneAutre = val("#sav-panne-autre");
      var unspecified = i18n("sav.recap.unspecified");
      var panneLabel;
      if (panneSlug === "autre") {
        panneLabel = panneAutre || PANNE_LABELS.autre;
      } else if (panneSlug) {
        panneLabel = PANNE_LABELS[panneSlug] || panneSlug;
      } else {
        panneLabel = unspecified;
      }

      // Lignes profil : affichees uniquement si la donnee est presente.
      var typeLabel = accountType ? (ACCOUNT_TYPE_LABELS[accountType] || accountType) : "";
      var langLabel = custLang ? (LANG_LABELS[custLang.toUpperCase()] || custLang) : "";

      var rows = [
        [i18n("sav.recap.account_type"), typeLabel || unspecified],
        [i18n("sav.recap.contact"), (fullName || unspecified) + " (" + form.dataset.customerEmail + ")"],
      ];
      if (custCompany) rows.push([i18n("sav.step1.company"), custCompany]);
      rows.push([i18n("account.form.phone"), val("#sav-phone") || unspecified]);
      rows.push([i18n("sav.step1.address"), val("#sav-address") || unspecified]);
      if (langLabel) rows.push([i18n("account.form.language"), langLabel]);
      rows = rows.concat([
        [i18n("sav.steps.product"), val("#sav-product") || unspecified],
        [i18n("sav.step2.fault_type"), panneLabel],
        [i18n("sav.recap.problem"), val("#sav-description")],
        [i18n("sav.steps.serial"), val("#sav-serial") || unspecified],
        [i18n("sav.recap.order"), val("#sav-order") || unspecified],
        [i18n("sav.recap.photo_product"), files.photo_product ? files.photo_product.name : "-"],
        [i18n("sav.recap.photo_serial"), files.photo_serial ? files.photo_serial.name : "-"],
        [i18n("account.orders.invoice"), files.invoice ? files.invoice.name : i18n("sav.recap.not_provided")],
      ]);
      recap.innerHTML = rows.map(function (r) {
        return '<div class="sav-recap__row"><dt class="sav-recap__key"></dt><dd class="sav-recap__val"></dd></div>';
      }).join("");
      var rowEls = recap.querySelectorAll(".sav-recap__row");
      rows.forEach(function (r, i) {
        rowEls[i].querySelector(".sav-recap__key").textContent = r[0];
        rowEls[i].querySelector(".sav-recap__val").textContent = r[1];
      });
    }
    function val(sel) {
      var el = form.querySelector(sel);
      return el ? el.value.trim() : "";
    }

    // ---- Feedback ---------------------------------------------------------
    function setFeedback(msg, kind) {
      feedback.textContent = msg;
      feedback.className = "sav-form__feedback" + (kind ? " is-" + kind : "");
    }
    function clearFeedback() { setFeedback("", ""); }

    // ---- Soumission -------------------------------------------------------
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      // Honeypot
      var hp = form.querySelector('[name="company_url"]');
      if (hp && hp.value.trim() !== "") { showSuccess("SAV-XXXX"); return; }
      if (!consent.checked) { setFeedback(i18n("sav.errors.consent"), "error"); return; }
      if (!files.photo_product || !files.photo_serial) {
        setFeedback(i18n("sav.errors.files_missing"), "error");
        return;
      }
      submit();
    });

    function ext(file) {
      var fromName = (file.name.split(".").pop() || "").toLowerCase();
      if (fromName && fromName.length <= 5) return fromName;
      if (file.type === "application/pdf") return "pdf";
      return (file.type.split("/").pop() || "jpg").toLowerCase();
    }

    async function submit() {
      // Garde anti double-soumission (double-clic ou touche Entree pendant l'envoi) :
      // chaque envoi genere un nouveau request_id, un 2e envoi creerait une demande en
      // double avec un 2e accuse de reception. On verrouille tant qu'un envoi est en cours.
      if (submitBtn.disabled) return;
      submitBtn.disabled = true;
      submitBtn.classList.add("is-loading");
      submitBtn.textContent = i18n("sav.step5.sending");
      setFeedback(i18n("sav.step5.preparing"), "info");
      try {
        // 1) URLs d'upload signees (facture facultative : on ne la demande que si presente)
        var slots = ["photo_product", "photo_serial"];
        if (files.invoice) slots.push("invoice");
        var fileList = slots.map(function (slot) {
          return { slot: slot, ext: ext(files[slot]) };
        });
        var prep = await postJson(apiBase + "/sav/upload-url", {
          customer_id: form.dataset.customerId,
          files: fileList,
        });
        if (!prep.ok) throw new Error(prep.error || i18n("sav.step5.prep_failed"));

        // 2) Upload direct de chaque fichier
        setFeedback(i18n("sav.step5.uploading"), "info");
        var paths = {};
        for (var slot in prep.uploads) {
          var u = prep.uploads[slot];
          await putFile(u.uploadUrl, files[slot]);
          paths[slot] = u.path;
        }

        // 3) Creation de la demande
        setFeedback(i18n("sav.step5.saving"), "info");
        var fullName = (val("#sav-firstname") + " " + val("#sav-lastname")).trim();

        // Snapshot profil 03f : tous les champs sont optionnels cote serveur,
        // on ne bloque jamais l'envoi s'ils sont vides.
        var snapshotPayload = {};
        if (accountType) snapshotPayload.account_type = accountType;
        if (custLang)    snapshotPayload.customer_lang = custLang;
        if (custCompany) snapshotPayload.company_name  = custCompany;
        if (custVat)     snapshotPayload.vat_number     = custVat;
        if (custCountry) snapshotPayload.customer_country = custCountry;
        if (custActivity) snapshotPayload.activity       = custActivity;

        var created = await postJson(apiBase + "/sav/create", Object.assign({
          request_id: prep.request_id,
          customer: {
            id: form.dataset.customerId,
            email: form.dataset.customerEmail,
            name: fullName || form.dataset.customerName,
            segment: form.dataset.customerSegment,
          },
          product_label: val("#sav-product"),
          serial_number: val("#sav-serial"),
          order_reference: val("#sav-order"),
          description: val("#sav-description"),
          customer_phone: val("#sav-phone"),
          customer_address: val("#sav-address"),
          panne_type: val("#sav-panne-type"),
          panne_autre: val("#sav-panne-autre"),
          paths: paths,
        }, snapshotPayload));
        if (!created.ok) throw new Error(created.error || i18n("sav.step5.save_failed"));
        showSuccess(created.reference);
      } catch (err) {
        submitBtn.disabled = false;
        submitBtn.classList.remove("is-loading");
        submitBtn.textContent = i18n("sav.step5.submit");
        setFeedback((err && err.message) || i18n("sav.errors.network"), "error");
      }
    }

    function showSuccess(reference) {
      panels.forEach(function (p) { p.classList.remove("is-active"); });
      var progress = form.querySelector("[data-sav-progress]");
      if (progress) progress.style.display = "none";
      var refEl = form.querySelector("[data-success-ref]");
      if (refEl) refEl.textContent = reference;
      successEl.hidden = false;
      var top = form.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: "smooth" });
      // Signale la creation pour que la vue "Mes demandes" se recharge.
      try {
        document.dispatchEvent(new CustomEvent("fog:sav-created", { detail: { reference: reference } }));
      } catch (e) {}
    }

    async function postJson(url, payload) {
      var res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok) throw new Error(data.error || i18n("sav.errors.http", { status: res.status }));
      return data;
    }

    async function putFile(url, file) {
      // Content-Type explicite : un .heic/.heif a souvent file.type vide sur desktop ; sans
      // ce repli sur l'extension il partirait en application/octet-stream, refuse par le bucket.
      var ctype = effectiveType(file) || "application/octet-stream";
      var res = await fetch(url, {
        method: "PUT",
        headers: { "Content-Type": ctype },
        body: file,
      });
      if (!res.ok) throw new Error(i18n("sav.errors.upload_failed"));
      return res;
    }
  }

  /* ============================================================
     Vue "Mes demandes" : suivi client (lecture seule)
     ============================================================ */
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString(window.FOG_I18N.intl("fr-FR"), {
        day: "2-digit", month: "long", year: "numeric",
      });
    } catch (e) { return ""; }
  }

  // Helpers reseau pour les widgets de reponse (03c).
  var RESP_MAX_BYTES = 10 * 1024 * 1024;
  function apiPost(url, payload) {
    return fetch(url, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok || !d.ok) throw new Error((d && d.error) || i18n("sav.errors.http", { status: r.status }));
        return d;
      });
    });
  }
  function apiPut(url, file) {
    // Meme repli MIME que putFile (heic/heif sans file.type sur desktop).
    var ctype = effectiveType(file) || "application/octet-stream";
    return fetch(url, {
      method: "PUT", headers: { "Content-Type": ctype }, body: file,
    }).then(function (r) { if (!r.ok) throw new Error(i18n("sav.reply.file_send_failed")); return r; });
  }
  function fileExt(file) {
    var n = (file.name.split(".").pop() || "").toLowerCase();
    if (n && n.length <= 5) return n;
    if (file.type === "application/pdf") return "pdf";
    return (file.type.split("/").pop() || "jpg").toLowerCase();
  }

  function initList(root) {
    if (!root || root.dataset.savListReady) return;
    root.dataset.savListReady = "1";

    var apiBase = "/apps/fog"; // App Proxy signe (cf. formulaire SAV ci-dessus)
    var customerId = root.dataset.customerId || "";
    var customerEmail = root.dataset.customerEmail || "";
    var body = root.querySelector("[data-sav-list-body]");
    var refreshBtn = root.querySelector("[data-sav-refresh]");

    // Sections soeurs : bouton "nouvelle demande" et conteneur du formulaire.
    var section = root.closest(".sav") || document;
    var newWrap = section.querySelector("[data-sav-new]");
    var newCta = section.querySelector("[data-sav-new-cta]");
    var openBtn = section.querySelector("[data-sav-open-form]");

    function showForm(scroll) {
      if (newWrap) newWrap.hidden = false;
      if (newCta) newCta.hidden = true;
      if (scroll && newWrap) {
        var top = newWrap.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: "smooth" });
      }
    }
    function offerForm() {
      // Une demande existe deja : le formulaire reste accessible derriere un bouton.
      if (newWrap) newWrap.hidden = true;
      if (newCta) newCta.hidden = false;
    }

    if (openBtn) openBtn.addEventListener("click", function () {
      try { document.dispatchEvent(new CustomEvent("fog:sav-reset")); } catch (e) {}
      showForm(true);
    });

    function setLoading() {
      // Pas de seconde lecture pendant la premiere (clic sur l'actualisation).
      if (refreshBtn) refreshBtn.disabled = true;
      body.innerHTML = "";
      var l = el("div", "sav-list__loading");
      l.appendChild(el("span", "sav-spinner"));
      l.appendChild(el("span", null, i18n("sav.list.loading")));
      body.appendChild(l);
    }

    function setError() {
      body.innerHTML = "";
      var wrap = el("div", "sav-list__error");
      wrap.appendChild(el("span", null, i18n("sav.list.load_error")));
      var retry = el("button", "sav-link", i18n("sav.list.retry"));
      retry.type = "button";
      retry.addEventListener("click", load);
      wrap.appendChild(retry);
      body.appendChild(wrap);
      // Ne pas bloquer l'ouverture d'une nouvelle demande si le suivi echoue.
      offerForm();
    }

    function renderEmpty() {
      body.innerHTML = "";
      var empty = el("div", "sav-list__empty");
      empty.appendChild(el("p", "sav-list__empty-title", i18n("sav.list.empty_title")));
      empty.appendChild(el("p", "sav-list__empty-text", i18n("sav.list.empty_text")));
      body.appendChild(empty);
    }

    // Widget de reponse client (03c) : message / fichier / choix, selon l action.
    function renderResponse(action) {
      var input = action.input || {};
      var wrap = el("div", "sav-resp");
      if (input.prompt) wrap.appendChild(el("p", "sav-resp__prompt", input.prompt));
      var feedback = el("p", "sav-resp__feedback");
      function ok(m) { feedback.className = "sav-resp__feedback is-ok"; feedback.textContent = m; }
      function ko(m) { feedback.className = "sav-resp__feedback is-err"; feedback.textContent = m; }
      function send(payload) {
        return apiPost(apiBase + "/sav/respond", Object.assign(
          { customer_id: customerId, customer_email: customerEmail, event_id: action.event_id }, payload));
      }

      if (input.kind === "message") {
        var ta = el("textarea", "sav-resp__text"); ta.rows = 3; ta.placeholder = i18n("sav.reply.message_placeholder");
        var btn = el("button", "btn-primary sav-resp__send", i18n("sav.reply.send")); btn.type = "button";
        btn.addEventListener("click", function () {
          var m = ta.value.trim(); if (!m) { ko(i18n("sav.reply.message_required")); return; }
          btn.disabled = true; ok(i18n("sav.reply.sending"));
          send({ message: m })
            .then(function () { ok(i18n("sav.reply.message_sent")); setTimeout(load, 700); })
            .catch(function (e) { btn.disabled = false; ko(e.message || i18n("sav.reply.error")); });
        });
        wrap.appendChild(ta); wrap.appendChild(btn);

      } else if (input.kind === "choix") {
        var row = el("div", "sav-resp__choices");
        (input.choices || []).forEach(function (ch) {
          var b = el("button", "sav-resp__choice " + (ch.value === "accepter" ? "btn-primary" : "btn-secondary"), ch.label);
          b.type = "button";
          b.addEventListener("click", function () {
            Array.prototype.forEach.call(row.querySelectorAll("button"), function (x) { x.disabled = true; });
            ok(i18n("sav.reply.sending"));
            send({ choix: ch.value })
              .then(function () { ok(i18n("sav.reply.choice_saved")); setTimeout(load, 700); })
              .catch(function (e) {
                Array.prototype.forEach.call(row.querySelectorAll("button"), function (x) { x.disabled = false; });
                ko(e.message || i18n("sav.reply.error"));
              });
          });
          row.appendChild(b);
        });
        wrap.appendChild(row);

      } else if (input.kind === "fichier") {
        var fileInput = el("input", "sav-resp__file"); fileInput.type = "file";
        if (input.fileAccept) fileInput.accept = input.fileAccept;
        var msg = el("textarea", "sav-resp__text"); msg.rows = 2; msg.placeholder = i18n("sav.reply.file_message_placeholder");
        var sbtn = el("button", "btn-primary sav-resp__send", i18n("sav.reply.send")); sbtn.type = "button";
        sbtn.addEventListener("click", function () {
          var f = fileInput.files && fileInput.files[0];
          if (!f) { ko(i18n("sav.reply.file_required")); return; }
          if (f.size > RESP_MAX_BYTES) { ko(i18n("sav.errors.file_too_large")); return; }
          sbtn.disabled = true; ok(i18n("sav.reply.file_sending"));
          apiPost(apiBase + "/sav/respond-upload", {
            customer_id: customerId, customer_email: customerEmail, event_id: action.event_id, ext: fileExt(f),
          })
            .then(function (prep) { return apiPut(prep.uploadUrl, f).then(function () { return prep.path; }); })
            .then(function (path) { return send({ file_path: path, message: msg.value.trim() }); })
            .then(function () { ok(i18n("sav.reply.file_sent")); setTimeout(load, 800); })
            .catch(function (e) { sbtn.disabled = false; ko(e.message || i18n("sav.reply.error")); });
        });
        wrap.appendChild(fileInput);
        if (input.withMessage) wrap.appendChild(msg);
        wrap.appendChild(sbtn);
      }

      wrap.appendChild(feedback);
      return wrap;
    }

    // Fichiers client (erreur B) : la demande initiale (photos + facture) et les
    // pieces jointes de reponse ne sont jamais telechargeables directement (aucun
    // path expose par /sav/list) : chaque clic demande une URL signee a la volee
    // (TTL court, consommee immediatement) puis ouvre l onglet.
    var FILE_SLOT_LABELS = {
      photo_product: i18n("sav.step2.photo_label"),
      photo_serial: i18n("sav.files.photo_plate"),
      invoice: i18n("account.orders.invoice"),
    };

    function openSavFile(btn, feedbackEl, params) {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add("is-loading");
      if (feedbackEl) { feedbackEl.hidden = true; feedbackEl.textContent = ""; }
      var qs = "reference=" + encodeURIComponent(params.reference);
      qs += params.slot
        ? "&slot=" + encodeURIComponent(params.slot)
        : "&event_id=" + encodeURIComponent(params.event_id);
      fetch(apiBase + "/sav/file?" + qs, { headers: { Accept: "application/json" } })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) {
            if (!r.ok || !d.ok) throw new Error((d && d.error) || i18n("sav.files.not_found"));
            return d;
          });
        })
        .then(function (d) { window.open(d.url, "_blank", "noopener"); })
        .catch(function (e) {
          if (feedbackEl) {
            feedbackEl.hidden = false;
            feedbackEl.textContent = (e && e.message) || i18n("sav.files.open_error");
          }
        })
        .then(function () {
          btn.disabled = false;
          btn.classList.remove("is-loading");
        });
    }

    function fileButton(reference, params, label) {
      var item = el("div", "sav-files__item");
      var btn = el("button", "sav-files__btn");
      btn.type = "button";
      btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
      btn.querySelector("span").textContent = label;
      var feedbackEl = el("span", "sav-files__error");
      feedbackEl.hidden = true;
      btn.addEventListener("click", function () {
        openSavFile(btn, feedbackEl, Object.assign({ reference: reference }, params));
      });
      item.appendChild(btn);
      item.appendChild(feedbackEl);
      return item;
    }

    function renderFilesBlock(reqData) {
      var slots = Object.keys(FILE_SLOT_LABELS).filter(function (slot) {
        return reqData.files && reqData.files[slot];
      });
      if (!slots.length) return null;
      var wrap = el("div", "sav-files");
      wrap.appendChild(el("p", "sav-files__title", i18n("sav.files.title")));
      var list = el("div", "sav-files__list");
      slots.forEach(function (slot) {
        list.appendChild(fileButton(reqData.reference, { slot: slot }, FILE_SLOT_LABELS[slot]));
      });
      wrap.appendChild(list);
      return wrap;
    }

    function renderTimeline(history, reference) {
      var ul = el("ul", "sav-timeline");
      (history || []).forEach(function (h) {
        var li = el("li", "sav-timeline__item");
        li.appendChild(el("span", "sav-timeline__dot"));
        var c = el("div", "sav-timeline__content");
        c.appendChild(el("span", "sav-timeline__label", h.label));
        if (h.detail) c.appendChild(el("p", "sav-timeline__detail", h.detail));
        c.appendChild(el("span", "sav-timeline__date", formatDate(h.at)));
        if (h.action && h.action.event_id && h.action.input) c.appendChild(renderResponse(h.action));
        if (h.file && h.file.event_id) {
          c.appendChild(fileButton(reference, { event_id: h.file.event_id }, i18n("sav.files.attachment")));
        }
        li.appendChild(c);
        ul.appendChild(li);
      });
      return ul;
    }

    function renderRequest(reqData, index) {
      var article = el("article", "sav-req");

      var head = el("button", "sav-req__head");
      head.type = "button";
      head.setAttribute("aria-expanded", "false");

      var main = el("div", "sav-req__main");
      var ref = el("span", "sav-req__ref", reqData.reference || i18n("sav.list.request_fallback"));
      main.appendChild(ref);
      var meta = el("span", "sav-req__meta",
        formatDate(reqData.created_at)
        + (reqData.product_label ? " · " + reqData.product_label : ""));
      main.appendChild(meta);
      head.appendChild(main);

      var badge = el("span", "sav-badge sav-badge--" + (reqData.status || "nouvelle"),
        reqData.status_label || reqData.status || "");
      head.appendChild(badge);

      var chevron = el("span", "sav-req__chevron");
      chevron.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      head.appendChild(chevron);

      var detail = el("div", "sav-req__detail");
      detail.hidden = true;
      var filesBlock = renderFilesBlock(reqData);
      if (filesBlock) detail.appendChild(filesBlock);
      if (reqData.history && reqData.history.length) {
        detail.appendChild(el("p", "sav-req__detail-title", i18n("sav.list.history")));
        detail.appendChild(renderTimeline(reqData.history, reqData.reference));
      } else {
        detail.appendChild(el("p", "sav-req__detail-empty", i18n("sav.list.no_events")));
      }

      head.addEventListener("click", function () {
        var open = article.classList.toggle("is-open");
        head.setAttribute("aria-expanded", open ? "true" : "false");
        detail.hidden = !open;
      });

      article.appendChild(head);
      article.appendChild(detail);
      return article;
    }

    function render(requests) {
      if (!requests || !requests.length) {
        renderEmpty();
        showForm(false); // premier contact : on montre directement le formulaire
        return;
      }
      body.innerHTML = "";
      var listEl = el("div", "sav-req-list");
      requests.forEach(function (r, i) { listEl.appendChild(renderRequest(r, i)); });
      body.appendChild(listEl);
      // Rechargement qui suit un envoi : l'ecran de succes (dans le formulaire) reste
      // affiche, seul le bouton « nouvelle demande » apparait (constat L5-01).
      var success = section.querySelector("[data-success]");
      if (success && !success.hidden && newWrap && !newWrap.hidden) {
        if (newCta) newCta.hidden = false;
        return;
      }
      offerForm(); // des demandes existent : formulaire derriere un bouton
    }

    function load() {
      if (!apiBase || !customerId || !customerEmail) { setError(); return; }
      setLoading();
      // L'identite vient de la signature App Proxy (logged_in_customer_id) : aucun
      // parametre. L'email ne passe plus dans l'URL (journaux Vercel), revue du 15/10.
      fetch(apiBase + "/sav/list", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (data) {
          if (!data || !data.ok) throw new Error((data && data.error) || "Erreur");
          if (refreshBtn) refreshBtn.hidden = false;
          render(data.requests || []);
        })
        .catch(function () { setError(); })
        .then(function () { if (refreshBtn) refreshBtn.disabled = false; });
    }

    if (refreshBtn) refreshBtn.addEventListener("click", load);
    // Recharge la liste apres une soumission reussie du formulaire.
    document.addEventListener("fog:sav-created", function () { load(); });

    load();
  }

  function boot() {
    // Memorise l'intention d'aller au SAV avant la connexion : le script global de
    // theme.liquid ramenera le client sur /pages/sav une fois connecte.
    document.querySelectorAll("[data-sav-login]").forEach(function (a) {
      a.addEventListener("click", function () {
        try { localStorage.setItem("fog_sav_return", String(Date.now())); } catch (e) {}
      });
    });
    document.querySelectorAll("[data-sav-list]").forEach(initList);
    document.querySelectorAll("[data-sav-form]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
